import {
    hasSelectedProject,
    getSelectedProjectId,
    closeCurrentTimeStreamProject,
    onTimeStreamAssetsDeleted,
    onAssetsLoaded,
    deleteTimeStreamProject,
} from 'owa-timestream-store';
import {
    clearSelectedAssets,
    deleteSelectedAssets,
    selectAsset,
    toggleAssetSelection,
} from '../actions';
import { mutator } from 'satcheljs';
import getSelectedAssets from '../selectors/getSelectedAssets';

mutator(selectAsset, ({ assetId }) => {
    resetSelectedAssets();
    getSelectedAssets().push(assetId);
});

mutator(toggleAssetSelection, ({ assetId }) => {
    const selectedAssets = getSelectedAssets();
    const index = selectedAssets.indexOf(assetId);
    if (index != -1) {
        selectedAssets.splice(index, 1);
    } else {
        selectedAssets.push(assetId);
    }
});

mutator(onTimeStreamAssetsDeleted, ({ assetIds }) => {
    const selectedAssets = getSelectedAssets();
    assetIds.forEach(assetId => {
        const index = selectedAssets.indexOf(assetId);
        if (index != -1) {
            selectedAssets.splice(index, 1);
        }
    });
});

mutator(clearSelectedAssets, resetSelectedAssets);
mutator(closeCurrentTimeStreamProject, resetSelectedAssets);
mutator(deleteSelectedAssets, resetSelectedAssets);
mutator(deleteTimeStreamProject, ({ projectId }) => {
    if (hasSelectedProject() && getSelectedProjectId() === projectId) {
        resetSelectedAssets();
    }
});

function resetSelectedAssets() {
    getSelectedAssets().splice(0);
}

mutator(onAssetsLoaded, ({ projectId, validAssetIds }) => {
    if (projectId == getSelectedProjectId()) {
        const validSelectedItems = getSelectedAssets().filter(assetId => !!validAssetIds[assetId]);
        resetSelectedAssets();
        validSelectedItems.forEach(assetId => getSelectedAssets().push(assetId));
    }
});
